import React from 'react';
import PropTypes from 'prop-types';
import './Chip.scss';

import Text from '../text/Text';
import RawIcon from '../system-icons/RawIcon';

function Chip({
  iconSrc, iconColor, text, children,
  onClick,
  backgroundColor,
  textColor,
}) {
  return (
    <button className="chip" type="button" onClick={onClick} style={{ backgroundColor }}>
      {iconSrc != null && <RawIcon src={iconSrc} color={iconColor} size="extra-small" />}
      {(text != null && text !== '') && <Text variant="b3" style={{ color: textColor }}>{text}</Text>}
      {children}
    </button>
  );
}

Chip.propTypes = {
  iconSrc: PropTypes.string,
  iconColor: PropTypes.string,
  text: PropTypes.string,
  children: PropTypes.element,
  onClick: PropTypes.func,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
};

Chip.defaultProps = {
  iconSrc: null,
  iconColor: null,
  text: null,
  children: null,
  onClick: null,
  backgroundColor: null,
  textColor: null,
};

export default Chip;
